module.exports = __webpack_public_path__ + "img/arrow_right.dfec5383.svg";